var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sys-select-base", {
        class: _vm.classe,
        attrs: {
          model: _vm.selected,
          items: _vm.items,
          loading: _vm.loading,
          label: _vm.label,
          error: _vm.error,
          errors: _vm.errors,
          clearable: _vm.clearable,
          showAdd: _vm.showAdd,
          dense: _vm.dense,
          multiple: _vm.multiple,
          autoComplete: _vm.autoComplete,
          disabled: _vm.disabled,
          outlined: _vm.outlined,
          hideDetails: _vm.hideDetails,
          classe: _vm.classe,
          "background-color": _vm.backgroundColor,
          color: _vm.color,
          "select-all": _vm.selectAll,
        },
        on: {
          "update:model": function ($event) {
            _vm.selected = $event
          },
          onShowForm: function ($event) {
            _vm.showForm = true
          },
          change: function ($event) {
            return _vm.$emit("change", $event)
          },
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
      }),
      _c("sys-register-brand", {
        attrs: { model: {}, show: _vm.showForm },
        on: {
          onCompleted: _vm.newItem,
          "update:show": function ($event) {
            _vm.showForm = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }